import React from "react";
import masterData from "../../lib/masterData";
import { OptionButton } from "../../common/OptionButton";

export class AssetType extends React.Component {
  render() {
    return (
      <OptionButton
        multi={true}
        options={masterData.assetType.list}
        value={this.props.value}
        onChangeValue={this.props.onChangeValue}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./pages/area/AssetType.jsx